<template>
    <div id="snb_bg" class="snb3">
        <div id="snb_text_area">
            <ul id="snb_text" class="snb_serv_secu">
                <li class="product" style="min-width: 170px">
                    <div class='big-line'></div>
                    <div class="big_inner">
                        <div class="big_title">
                            <a href="/en/secu_supp/secu_supp/0">
                                <h4>Center Guide</h4>
                            </a>
                        </div>
                    </div>
                    <div class="small_grp">
                        <div class='small-line'></div>
                        <div class="small_inner">
                            <div class="small_title">
                                <a href="/en/secu_supp/secu_supp/0">
                                    <p>About ISARC</p>
                                </a>
                            </div>
                        </div>
                    </div>
                </li>
                <li class="product">
                    <div class='big-line'></div>
                    <div class="big_inner">
                        <div class="big_title">
                            <a href="/kr/board/security/list/isarc1?page=1">
                                <h4>Security Information</h4>
                            </a>
                        </div>
                    </div>
                    <div class="small_grp">
                        <div class='small-line'></div>
                        <div class="small_inner">
                            <div class="small_title">
                                <a href="/kr/board/security/list/isarc1?page=1">
                                    <p>Latest Malware Trends</p>
                                </a>
                            </div>
                            <div class="small_title">
                                <a href="/kr/board/security/list/isarc4?page=1">
                                    <p>Vulnerability Information</p>
                                </a>
                            </div>
                            <div class="small_title">
                                <a href="/kr/board/security/list/isarc5?page=1">
                                    <p>Engine Update</p>
                                </a>
                            </div>
                        </div>
                    </div>
                </li>
                <li class="product">
                    <div class='big-line'></div>
                    <div class="big_inner">
                        <div class="big_title">
                            <a href="/kr/board/security/list/isarc2?category=12&page=1">
                                <h4>Analysis Information</h4>
                            </a>
                        </div>
                    </div>
                    <div class="small_grp">
                        <div class='small-line'></div>
                        <div class="small_inner">
                            <div class="small_title">
                                <a href="/kr/board/security/list/isarc2?category=12&page=1">
                                    <p>Malware Analysis Reports</p>
                                </a>
                            </div>
                            <div class="small_title">
                                <a href="/kr/board/security/list/isarc2?category=13&page=1">
                                    <p>Ransomware Analysis Reports</p>
                                </a>
                            </div>
                            <div class="small_title">
                                <a href="/kr/board/security/list/isarc2?category=14&page=1">
                                    <p>Mobile Analysis Reports</p>
                                </a>
                            </div>
                            <div class="small_title">
                                <a href="/kr/board/security/list/isarc2?category=19&page=1">
                                    <p>Linux Analysis Reports</p>
                                </a>
                            </div>
                        </div>
                    </div>
                </li>
                <li class="product" style="min-width: 220px">
                    <div class='big-line'></div>
                    <div class="big_inner">
                        <div class="big_title">
                            <a href="/kr/board/security/list/isarc3?category=15&page=1">
                                <h4>Trend Report</h4>
                            </a>
                        </div>
                    </div>
                    <div class="small_grp">
                        <div class='small-line'></div>
                        <div class="small_inner">
                            <div class="small_title">
                                <a href="/kr/board/security/list/isarc3?category=15&page=1">
                                    <p>Monthly Trend Report</p>
                                </a>
                            </div>
                            <div class="small_title">
                                <a href="/kr/board/security/list/isarc3?category=16&page=1">
                                    <p>Quarterly Trend Report</p>
                                </a>
                            </div>
                            <div class="small_title">
                                <a href="/kr/board/security/list/isarc3?category=17&page=1">
                                    <p>Annual Trend Report</p>
                                </a>
                            </div>
                        </div>
                    </div>
                </li>
                <li class="product">
                    <div class='big-line'></div>
                    <div class="big_inner">
                        <div class="big_title">
                            <a onclick="window.open('/en/main_level','window_name','width=780,height=930,location=no,status=no,scrollbars=yes');" style="cursor:pointer;">
                                <h4>Extra Security Information</h4>
                            </a>
                        </div>
                    </div>
                    <div class="small_grp">
                        <div class='small-line'></div>
                        <div class="small_inner">
                            <div class="small_title">
                                <a onclick="window.open('/en/main_level','window_name','width=780,height=930,location=no,status=no,scrollbars=yes');" style="cursor:pointer;">
                                    <p>Security Alert Levels</p>
                                </a>
                            </div>
                            <div class="small_title">
                                <a onclick="window.open('/en/main_name','window_name','width=780,height=930,location=no,status=no,scrollbars=yes');">
                                    <p>Malware Naming</p>
                                </a>
                            </div>
                        </div>
                    </div>
                </li>
            </ul>
        </div>
    </div>
</template>
<script>
export default {
    mounted: function() {
        // this.loadMenus();
    },
    methods: {
        goArticleList(code, category) {
            console.log(code, category);
            this.$router.push({
                path: '/kr/board/security/list/' + code,
                query: {category:category}
            }).catch(()=>{});
        }
    }
}
</script>